import React from 'react'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import TourProgressBanner from '../../components/banners/TourInProgressBanner'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import { setTourInProgressBannerHidden } from '../../tourActions'

const mapStateToProps = state => ({
    isTourInProgressBannerHidden: state.getIn(['tour', 'isTourInProgressBannerHidden']),
    isTourInitializedComplete: state.getIn(['tour', 'isTourInitializedComplete']),
})

const mapDispatchToProps = dispatch => ({
    onClick: _ => {
        dispatch(setTourInProgressBannerHidden(true))
    },
})

const shouldRenderComponent = Component => ({
    tour: { status: tourStatus },
    location: { status: locationStatus },
    isTourInProgressBannerHidden,
    isTourInitializedComplete,
    ...props
}) => {
    return isTourInitializedComplete === true &&
        isTourInProgressBannerHidden !== true &&
        (tourStatus == 'inprogress' || locationStatus == 'inprogress') ? (
        <Component {...props} />
    ) : null
}

export default compose(
    connect(mapSelectorsToProps(['tour', 'location']), mapDispatchToProps),
    connect(mapStateToProps),
    shouldRenderComponent
)(TourProgressBanner)
